package com.bikompanion.ui.composables

import androidx.compose.ui.graphics.Color

/** One slice of an [AvailabilityBar]: how many of something there are, and how to draw and name it. */
internal data class AvailabilitySegment(
    val label: String,
    val count: Int,
    val color: Color,
)
